import type { ReactNode } from 'react'

interface SectionHeaderProps {
  label: string
  heading: ReactNode
  description?: string
  className?: string
}

export default function SectionHeader({
  label,
  heading,
  description,
  className = '',
}: SectionHeaderProps) {
  return (
    <div className={className}>
      <span className="text-primary font-body text-label-md uppercase tracking-[0.4em] mb-4 block">
        {label}
      </span>
      <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter">
        {heading}
      </h2>
      {description && (
        <p className="text-on-surface-variant text-base md:text-lg lg:text-xl max-w-2xl mt-4">
          {description}
        </p>
      )}
    </div>
  )
}
